<template>
  <div class="table-responsive">
    <table class="custom-table-grade" border="1">
      <thead>
      <tr>
        <th class="text-center fixed-column">Cor</th>
        <th v-for="size in sizes" :key="size" class="text-center">{{ size.toUpperCase() }}</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(row, index) in mergedData" :key="index">
        <td>{{ row.des_cor }}</td>
        <td v-for="size in sizes" :key="size">
          <input
              type="number"
              class="form-control"
              :value="row[size.toLowerCase()]"
              :disabled="row[size.toLowerCase()] === null"
              @input="updateColorAndSize({ cdn_cor: row.cdn_cor, des_cor: row.des_cor, cdn_tamanho: row.cdn_tamanho}, size, row , $event.target.value)"
          />
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'GradeItem',
  props: {
    value: {
      type: Array,
      required: true,
    },
    json: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      sizesData: [],
      mergedData: [],
    };
  },
  watch: {
    json: {
      handler(newJson) {
        this.mergedData = this.mergeJsons(this.value, newJson);
      },
      deep: true,
    },
    value: {
      handler(newValue) {
        this.mergedData = this.mergeJsons(newValue, this.json);
      },
      deep: true,
    },
  },
  mounted() {
    this.mergedData = this.mergeJsons(this.value, this.json);
  },
  computed: {
    sizes() {
      // Extrai os tamanhos das chaves do primeiro item
      if (this.value.length > 0) {
        return Object.keys(this.value[0]).filter((key) => key !== 'cdn_cor' && key !== 'des_cor' && key !== 'cdn_tamanho');
      }
      return [];
    },
  },
  methods: {
    mergeJsons(firstJson, secondJson) {
      const merged = secondJson.map((item) => {
        const { cdnCor: cdn_cor, desCor: des_cor, ...rest } = item;
        return {
          cdn_cor,
          des_cor,
          pp: rest.itemExtrapq ? {
            item_id: rest.itemExtrapq,
            des_tamanho: 'Extra Pequeno',
            cdn_tamanho: rest.itemTamanhoExtrapq,
            quantidade: rest.ExtraPequeno || null,
          } : null,
          p: rest.itemPequeno ? {
            item_id: rest.itemPequeno,
            des_tamanho: 'Pequeno',
            cdn_tamanho: rest.itemTamanhoPequeno,
            quantidade: rest.Pequeno || null,
          } : null,
          m: rest.itemMedio ? {
            item_id: rest.itemMedio,
            des_tamanho: 'Médio',
            cdn_tamanho: rest.itemTamanhoMedio,
            quantidade: rest.Medio || null,
          } : null,
          g: rest.itemGrande ? {
            item_id: rest.itemGrande,
            des_tamanho: 'Grande',
            cdn_tamanho: rest.itemTamanhoGrande,
            quantidade: rest.Grande || null,
          } : null,
          gg: rest.itemExtraGd ? {
            item_id: rest.itemExtraGd,
            des_tamanho: 'Extra Grande',
            cdn_tamanho: rest.itemTamanhoExtraGd,
            quantidade: rest.ExtraGrande || null,
          } : null,
          xg: rest.itemSuperGd ? {
            item_id: rest.itemSuperGd,
            des_tamanho: 'Super Grande',
            cdn_tamanho: rest.itemTamanhoSuperGd,
            quantidade: rest.SuperGrande || null,
          } : null,
          xgg: rest.itemUltraGd ? {
            item_id: rest.itemUltraGd,
            des_tamanho: 'Ultra Grande',
            cdn_tamanho: rest.itemTamanhoUltraGd,
            quantidade: rest.UltraGrande || null,
          } : null,
          unico: rest.itemUnico ? {
            item_id: rest.itemUnico,
            des_tamanho: 'Único',
            cdn_tamanho: rest.itemTamanhoUnico,
            quantidade: rest.Unico || null,
          } : null,
          diversos: rest.itemOutros ? {
            item_id: rest.itemOutros,
            des_tamanho: 'Outros',
            cdn_tamanho: rest.itemTamanhoOutros,
            quantidade: rest.Outros || 0,
          } : null,
        };
      });
      return merged;
    },

    updateColorAndSize(item, size, row, value) {
      // console.log('updateColorAndSize -->', item, size, value);

      // Converte valor vazio para 0
      if (value === '') {
        value = 0;
      }

      // Procura pelo índice no array sizesData com base na cdn_cor e tamanho
      const index = this.sizesData.findIndex((data) => data.cdn_cor === item.cdn_cor && data.tamanho === size.toLowerCase());

      // Se encontrou, atualiza o valor
      if (index !== -1) {
        this.$set(this.sizesData[index], 'valor', parseInt(value)); // Converte para número inteiro se necessário
      } else {
        // Se não encontrou, adiciona um novo objeto ao array sizesData
        this.sizesData.push({
          des_cor: item.des_cor,
          cdn_cor: item.cdn_cor,
          tamanho: size.toLowerCase(),
          cdn_tamanho: item.cdn_tamanho,
          valor: parseInt(value), // Converte para número inteiro se necessário
        });
      }

      // Exibe o array sizesData no console para verificação
      // console.log('sizesData', this.sizesData);

      this.sizesData.forEach((item) => {
        // Encontrar o item correspondente em mergedData
        let foundItem = null;

        // Percorre os itens em mergedData
        this.mergedData.forEach((data) => {
          if (data.des_cor === item.des_cor && data[item.tamanho.toLowerCase()]) {
            foundItem = data[item.tamanho.toLowerCase()];
          }
        });

        if (foundItem) {
          // Inserir item_id no item
          item.item_id = foundItem.item_id;
        } else {
          console.log('Item não encontrado para:', item);
        }
      });

      // Exibir sizesData atualizado

      // Emite um evento para atualizar a propriedade do pai com os dados atualizados
      this.$emit('update:grade', this.sizesData);
    },

  },
};
</script>

<style scoped>
.custom-table-grade th,
.custom-table-grade td {
  text-align: center;
  padding: 5px;
}

.table-responsive {
  overflow-x: auto;
}

.fixed-column {
  position: sticky;
  left: 0;
  background-color: white;
  z-index: 2;
}
</style>
